export class NewsAndPromotions {
	newsId: string;
	url: string;
    inactive: string;
    notes: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/dashboard/NewsAndPromotions.ts